import {
  BUSINESS_TYPES_LOOKUP_REQUEST,
  BUSINESS_TYPES_LOOKUP_RESPONSE,
  BUSINESS_VERIFICATION_STATUS_LOOKUP_REQUEST,
  BUSINESS_VERIFICATION_STATUS_LOOKUP_RESPONSE,
  BUSINESS_VERIFICATION_TYPES_LOOKUP_REQUEST,
  BUSINESS_VERIFICATION_TYPES_LOOKUP_RESPONSE,
  CATEGORIES_LOOKUP_REQUEST,
  CATEGORIES_LOOKUP_RESPONSE,
  COMPANIES_LOOKUP_REQUEST,
  COMPANIES_LOOKUP_RESPONSE,
  COUNTRIES_LOOKUP_REQUEST,
  COUNTRIES_LOOKUP_RESPONSE,
  EXPORTERS_LOOKUP_REQUEST,
  EXPORTERS_LOOKUP_RESPONSE,
  PRICING_PLANS_LOOKUP_REQUEST,
  PRICING_PLANS_LOOKUP_RESPONSE,
  ROLES_LOOKUP_REQUEST,
  ROLES_LOOKUP_RESPONSE,
  SUB_CATEGORIES_LOOKUP_REQUEST,
  SUB_CATEGORIES_LOOKUP_RESPONSE,
  TRANSACTION_PAYMENT_REASONS_LOOKUP_REQUEST,
  TRANSACTION_PAYMENT_REASONS_LOOKUP_RESPONSE,
  TRANSACTION_STATUS_LOOKUP_REQUEST,
  TRANSACTION_STATUS_LOOKUP_RESPONSE,
  VOUCHER_COMPANIES_LOOKUP_REQUEST,
  VOUCHER_COMPANIES_LOOKUP_RESPONSE
} from "./types";

export const categoriesLookupRequest = () => ({
  type: CATEGORIES_LOOKUP_REQUEST
});
export const categoriesLookupResponse = (payload) => ({
  type: CATEGORIES_LOOKUP_RESPONSE,
  payload
});

export const subCategoriesLookupRequest = (payload) => ({
  type: SUB_CATEGORIES_LOOKUP_REQUEST,
  payload
});
export const subCategoriesLookupResponse = (payload) => ({
  type: SUB_CATEGORIES_LOOKUP_RESPONSE,
  payload
});

export const countriesLookupRequest = (payload) => ({
  type: COUNTRIES_LOOKUP_REQUEST,
  payload
});
export const countriesLookupResponse = (payload) => ({
  type: COUNTRIES_LOOKUP_RESPONSE,
  payload
});

export const exportersLookupRequest = (payload) => ({
  type: EXPORTERS_LOOKUP_REQUEST,
  payload
});
export const exportersLookupResponse = (payload) => ({
  type: EXPORTERS_LOOKUP_RESPONSE,
  payload
});

export const companiesLookupRequest = (payload) => ({
  type: COMPANIES_LOOKUP_REQUEST,
  payload
});
export const companiesLookupResponse = (payload) => ({
  type: COMPANIES_LOOKUP_RESPONSE,
  payload
});

export const businessVerificationTypesLookupRequest = (payload) => ({
  type: BUSINESS_VERIFICATION_TYPES_LOOKUP_REQUEST,
  payload
});
export const businessVerificationTypesLookupResponse = (payload) => ({
  type: BUSINESS_VERIFICATION_TYPES_LOOKUP_RESPONSE,
  payload
});

export const businessTypesLookupRequest = (payload) => ({
  type: BUSINESS_TYPES_LOOKUP_REQUEST,
  payload
});
export const businessTypesLookupResponse = (payload) => ({
  type: BUSINESS_TYPES_LOOKUP_RESPONSE,
  payload
});

export const businessVerificationStatusLookupRequest = (payload) => ({
  type: BUSINESS_VERIFICATION_STATUS_LOOKUP_REQUEST,
  payload
});
export const businessVerificationStatusLookupResponse = (
  payload
) => ({
  type: BUSINESS_VERIFICATION_STATUS_LOOKUP_RESPONSE,
  payload
});

export const voucherCompaniesLookupRequest = (payload) => ({
  type: VOUCHER_COMPANIES_LOOKUP_REQUEST,
  payload
});
export const voucherCompaniesLookupResponse = (payload) => ({
  type: VOUCHER_COMPANIES_LOOKUP_RESPONSE,
  payload
});

export const transactionPaymentReasonsLookupRequest = (payload) => ({
  type: TRANSACTION_PAYMENT_REASONS_LOOKUP_REQUEST,
  payload
});
export const transactionPaymentReasonsLookupResponse = (payload) => ({
  type: TRANSACTION_PAYMENT_REASONS_LOOKUP_RESPONSE,
  payload
});

export const transactionStatusLookupRequest = (payload) => ({
  type: TRANSACTION_STATUS_LOOKUP_REQUEST,
  payload
});
export const transactionStatusLookupResponse = (payload) => ({
  type: TRANSACTION_STATUS_LOOKUP_RESPONSE,
  payload
});

export const rolesLookupRequest = () => ({
  type: ROLES_LOOKUP_REQUEST
});
export const rolesLookupResponse = (payload) => ({
  type: ROLES_LOOKUP_RESPONSE,
  payload
});

export const pricingPlansLookupRequest = () => ({
  type: PRICING_PLANS_LOOKUP_REQUEST
});
export const pricingPlansLookupResponse = (payload) => ({
  type: PRICING_PLANS_LOOKUP_RESPONSE,
  payload
});
